export const ROLE_ID = {
  NDE_Administrator: 457,
  NDE_Reviewer: 410,
  NDE_Applicant: 411,
  NDE_Analyst: 412,
  NDE_LeadAnalyst: 413,
  Licensing_Analyst: 453,
  Licensing_LeadAnalyst: 452,
  Licensing_LeadTechnician: 454,
  Licensing_Technician: 455,
//notification roles
  Chief_Compliance_Investigator: 450,
  Compliance_Investigator: 451,
  Fingerprint_Vendor_Admin: 448,
  Fingerprint_Vendor_Staff: 447

}
